<script setup lang="ts">
    interface PreferenceOption {
        key: string;
        label: string;
    }

    defineProps<{
        title: string;
        description: string;
        options: PreferenceOption[];
        formData: Record<string, boolean>;
        helperText: string;
    }>();

    const emit = defineEmits<{toggle: [key: string];}>();
</script>

<template>
    <div class="border border-[#A0A2A4] rounded-2xl p-5 md:p-6 bg-white mt-8">
        <p class="font-semibold mb-1">{{ title }}</p>
        <p class="text-[#888B8D] mb-5">{{ description }}</p>

        <div class="flex flex-col md:flex-row flex-wrap gap-2 md:gap-3 mb-2">
            <label
                v-for="option in options"
                :key="option.key"
                :class="[
                    'flex items-center gap-2 px-5 py-3 rounded-full border transition cursor-pointer w-full md:w-auto',
                    formData[option.key]
                        ? 'border-black bg-[#161412] text-white'
                        : 'border-[#A0A2A4] text-[#6B7280]',
                ]"
            >
                <input
                    type="checkbox"
                    :checked="formData[option.key]"
                    @change="emit('toggle', option.key)"
                    class="marketing-checkbox w-[18px] h-[18px] rounded-[4px] border border-[#888B8D] accent-black cursor-pointer"
                />

                <span>{{ option.label }}</span>
            </label>
        </div>

        <p class="text-sm text-[#888B8D] leading-tight">
            {{ helperText }}
        </p>
    </div>
</template>

<style scoped>
    .marketing-checkbox {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;

        width: 18px;
        height: 18px;
        border-radius: 4px;
        border: 1px solid #888b8d;
        cursor: pointer;
        background: white;
        position: relative;
    }

    .marketing-checkbox:checked {
        background-color: black;
        border-color: black;
    }

    .marketing-checkbox:checked::after {
        content: '';
        position: absolute;
        left: 5px;
        top: 1px;
        width: 6px;
        height: 12px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
</style>